module.exports = __webpack_public_path__ + "img/9.6d449b58.png";